const isEmpty = require("../../common/functions/is-empty");

export function validateExcelHeaders(row) {
  let validationErrorsHeader = {};
  const validationSet = [
    "Item ERP Code (Optional)",
    "Item Description (Required)",
    "Specification (Required)",
    "Quantity For Sample (Required)",
    "Preferred Unit Of Measure (Required)",
    "Product Class (Required)",
  ];
  row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    if (cell.value !== validationSet[colNumber - 1]) {
      validationErrorsHeader.excelFile = `Headers in the file are not formed correctly, Please download the Template and try again.`;
    }
  });
  return {
    validationErrorsHeader,
    areHeadersValid: isEmpty(validationErrorsHeader),
  };
}
